<div class="textbox-container" fxLayout="column" fxLayoutGap=".3rem">
  <div class="label">{{label}}</div>
  <div class="text">{{addText}}@if (required) {
    <span class="mat-form-field-required-marker">&nbsp;&#42;</span>
  }</div>
</div>
